// extracted by mini-css-extract-plugin
module.exports = {"page_header":"KazakhstanPage_page_header__1S_l2","breadcrumbs":"KazakhstanPage_breadcrumbs__3fNzR","layout":"KazakhstanPage_layout__cgeUq"};